import { websiteTypographyMixin } from './websiteTypographyMixin';

export const predefinedWebsiteMixins = {
  headlines: {
    xxxxl: {
      contrastInvert: websiteTypographyMixin('headlines', 'xxxxl', 'contrastInvert'),
      bold: websiteTypographyMixin('headlines', 'xxxxl', 'bold'),
    },
    xxxl: {
      contrastInvert: websiteTypographyMixin('headlines', 'xxxl', 'contrastInvert'),
      bold: websiteTypographyMixin('headlines', 'xxxl', 'bold'),
    },
    xl: {
      contrastInvert: websiteTypographyMixin('headlines', 'xl', 'contrastInvert'),
      bold: websiteTypographyMixin('headlines', 'xl', 'bold'),
    },
    lg: {
      contrastInvert: websiteTypographyMixin('headlines', 'lg', 'contrastInvert'),
      bold: websiteTypographyMixin('headlines', 'lg', 'bold'),
    },
    md: {
      contrastInvertBold: websiteTypographyMixin('headlines', 'md', 'contrastInvertBold'),
      bold: websiteTypographyMixin('headlines', 'md', 'bold'),
      contrastInvert: websiteTypographyMixin('headlines', 'md', 'contrastInvert'),
      regular: websiteTypographyMixin('headlines', 'md', 'regular'),
    },
    sm: {
      contrastInvert: websiteTypographyMixin('headlines', 'sm', 'contrastInvert'),
      bold: websiteTypographyMixin('headlines', 'sm', 'bold'),
    },
  },
  brandText: {
    lg: {
      contrastInvert: websiteTypographyMixin('brandText', 'lg', 'contrastInvert'),
      bold: websiteTypographyMixin('brandText', 'lg', 'bold'),
      regular: websiteTypographyMixin('brandText', 'lg', 'regular'),
    },
    sm: {
      contrastInvert: websiteTypographyMixin('brandText', 'sm', 'contrastInvert'),
      bold: websiteTypographyMixin('brandText', 'sm', 'bold'),
      accentCoral: websiteTypographyMixin('brandText', 'sm', 'accentCoral'),
    },
    xs: {
      contrastInvert: websiteTypographyMixin('brandText', 'xs', 'contrastInvert'),
      regular: websiteTypographyMixin('brandText', 'xs', 'regular'),
    },
  },
};
